import React from 'react'
import queryString from 'query-string'
import { APP_NAME } from '../../brand'

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props)
    this.state = { status: 'loading', message: '' }
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search)
    if (!params.token) {
      this.setState({ status: 'error', message: 'Invalid link.' })
      return
    }
    // the backend handles verification and redirects to home
    // this page is a fallback if the redirect doesn't work (e.g. cookie issues)
    fetch('/endpoint/auth/email/verify?token=' + params.token, { redirect: 'manual' })
      .then(res => {
        if (res.ok || res.redirected) {
          window.location.href = '/'
        } else {
          return res.json().then(d => {
            this.setState({ status: 'error', message: d.message || 'That link is invalid or has expired.' })
          })
        }
      })
      .catch(() => {
        // redirect happened (fetch can't follow cross-origin redirects in some browsers)
        window.location.href = '/'
      })
  }

  render() {
    const { status, message } = this.state
    return (
      <div className="ng-container" style={{ maxWidth: 440, padding: '80px 20px', textAlign: 'center' }}>
        <div className="ng-panel">
          <div className="ng-wordmark" style={{ justifyContent: 'center', marginBottom: 20 }}>
            <span className="ng-wordmark-key">⌂</span>
            <span>{APP_NAME}</span>
          </div>
          {status === 'loading' ? (
            <div>
              <span className="fa fa-spinner fa-spin" style={{ fontSize: 32, color: 'var(--ng-primary)', display: 'block', marginBottom: 16 }}></span>
              <p>Confirming your email…</p>
            </div>
          ) : (
            <div>
              <span className="fa fa-exclamation-circle" style={{ fontSize: 48, color: '#ef4444', display: 'block', marginBottom: 16 }}></span>
              <p style={{ fontWeight: 700 }}>{message}</p>
              <button className="ng-btn ng-btn-primary ng-btn-sm" style={{ marginTop: 12 }}
                onClick={() => this.props.history.push('/')}>
                Go to home page
              </button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default VerifyEmail
